
import * as _ from 'lodash'
import * as React from 'react'

const floatRegex = new RegExp('^\\d*(\\.\\d*)?$')

export interface IPlainInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  disablePlaceholder?: boolean
  formattedNumberMode?: boolean
  showValidityErrors?: boolean
  forceRemoveValue?: boolean
}

export interface IPlainInputState {
  hasValue: boolean
  hasFocus: boolean
  value: string | number | string[]
}

export class PlainInput extends React.Component<IPlainInputProps, IPlainInputState> {
  state = {
    hasFocus: false,
    hasValue: false,
    value: 0
  }

  private inputElement: HTMLInputElement
  private lastValue: string | number

  componentWillMount() {
    let v = this.props.value
    let hasValue = !_.isNil(v)
    if (!hasValue) {
      v = this.props.defaultValue
      hasValue = !_.isNil(v)
    }
    const value = hasValue ? this.formatValue(v) : null

    this.setState({ hasValue, value })
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.focus()
    }
  }

  formatValue(value): string {
    if (_.isUndefined(value)) { return '' }
    return this.props.formattedNumberMode ? value.toLocaleString() : value.toString()
  }

  onChange(e: React.ChangeEvent<HTMLInputElement>): void {
    let value: string | number = e.currentTarget.value
    const hasValue = !!value

    if (value && typeof value === 'string') {
      if (this.props.formattedNumberMode) {
        value = value.replace(/,/g, '')
      }

      //const trailing = value.endsWith('.') ? '.' : ''

      const v = Number(value || '0').valueOf()
      if (isNaN(v)) {
        return
      }
      value = this.formatValue(v)
    }

    // tslint:disable-next-line:no-console
    //console.log('MaterialNumber: ' + value)

    // re-assign value so that it will show up (possiby formatted)
    e.target.value = value

    if (this.lastValue !== value) {
      this.setState({ hasValue, value })

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(e)
      }

      this.lastValue = value
    }
  }

  onFocusChange(e: React.FocusEvent<HTMLInputElement>, hasFocus: boolean) {
    this.setState({ hasFocus })
    if (hasFocus) {
      if (typeof this.props.onFocus === 'function') {
        this.props.onFocus(e)
      }
    } else if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(e)
    }
  }

  focus() {
    this.setState({ hasFocus: true }, () => {
      this.inputElement.focus()

      if (this.inputElement.value) {
        this.inputElement.selectionStart = this.inputElement.value.length
      }
    })
  }

  getClasses() {
    let classes = ''

    if (this.state.hasValue) {
      classes += ' hasValue'
    }

    if (this.state.hasFocus) {
      classes += ' hasFocus'
    }

    if (this.props.disablePlaceholder) {
      classes += ' disablePlaceholder'
    }

    if (this.props.showValidityErrors && this.inputElement) {
      if (!this.inputElement.validity.valid) {
        classes += ' has-error'
      }
    }

    return classes
  }

  render() {

    const { forceRemoveValue } = this.props
    const inputProps = { ...this.props }

    //remove non input props
    delete inputProps.placeholder
    delete inputProps.forceRemoveValue
    delete inputProps.showValidityErrors
    delete inputProps.disablePlaceholder
    delete inputProps.formattedNumberMode

    //Allow for consumers to set value to null
    if (inputProps.value === null || forceRemoveValue) {
      inputProps.value = ''
      this.state.value = 0
    }
    delete inputProps.value

    return (
      <span className={this.getClasses()}>
        <input className="form-control"
          { ...inputProps }
          value={this.state.value}
          ref={(inputElem) => this.inputElement = inputElem}
          onChange={(e) => this.onChange(e)}
          onFocus={(e) => this.onFocusChange(e, true)}
          onBlur={(e) => this.onFocusChange(e, false)}
        />
      </span>
    )
  }
}

export default PlainInput



// WEBPACK FOOTER //
// ./src/app/components/PlainInput/index.tsx